module.exports = __webpack_public_path__ + "static/media/ic_cvv_code.be5eefdc.svg";